import { render, staticRenderFns } from "./BookingRating.vue?vue&type=template&id=a88a4d58"
import script from "./BookingRating.vue?vue&type=script&lang=js"
export * from "./BookingRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports